<!--
* @description  客户中心底部
* @fileName  index
* @author dtms
* @date 2023-12-24 16:37:44
!-->
<template>
  <div id="ClientBottom" class="ClientBottom flex flex-column flex-column-center">
    <div class="flex flex-row-between foot-main">
      <div class="foot-left">
        <el-image :src="config.navigationIcon| toUrl()" fit="contain" alt="logo" style="height: 40px;">
          <template slot="error">
            <img src="@/assets/logo.png" height="40px">
          </template>
        </el-image>
        <div class="flex flex-column-center margin-left__24 margin-top_24">
          <a href="#" class="foot-left__link">解决方案</a>
          <a href="#" class="foot-left__link">海运散货</a>
          <a href="#" class="foot-left__link">快递服务</a>
          <a href="#" class="foot-left__link">亚马逊FBA</a>
        </div>
        <div class="flex flex-column-center margin-left__24 margin-top_16">
          <a href="#" class="foot-left__link">常见问题</a>
          <a href="#" class="foot-left__link">关于我们</a>
          <a href="#" class="foot-left__link">加入我们</a>
        </div>
      </div>
      <div class="foot-right">
        <!-- <img src="" alt="code" class="foot-right-code" width="112" height="112" />
				<div class="foot-right-code__text">扫码关注微信公众号</div> -->
      </div>
    </div>
    <div class="foot-bottom margin-top_24">
      Copyright {{ config.copyright }}, All Rights Reserved.
    </div>
    <!-- <div class='footMain'>
        <div class="foot-left">
            <div>Solutions</div>
            <div>Company</div>
            <div>Legal</div>
        </div>
        <div class="foot-right">
            <img src="../../assets/img/client/foot/icon_map_facebook.png" width="40px" height="40px">
            <img src="../../assets/img/client/foot/icon_map_twi.png"  width="40px" height="40px">
            <img src="../../assets/img/client/foot/icon_map_3.png"  width="40px" height="40px">
            <img src="../../assets/img/client/foot/icon_map_ins.png"  width="40px" height="40px">
        </div>
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'FootModule',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {}
  },
  computed: {
    // 计算属性
    config() {
      const config = this.$store.getters.config || {}
      return config
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
  }
}
</script>
<style scoped lang="scss">
	.ClientBottom {
		width: 100%;
		height: 224px;
		padding: 24px;
		background: url('../../assets/img/client/foot/bottombg.png');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		box-sizing: border-box;

		.foot-main {
			width: 1200px;

			.foot-left {
				text-align: left;

				.el-image {
					display: block;
				}

				.foot-left__link {
					margin-left: 24px;
					display: block;
					text-decoration: none;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: rgba(255, 255, 255, 0.8);
					line-height: 24px;
					text-align: left;
					font-style: normal;
					transition: all 0.3s ease-in-out;

					&:hover {
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 16px;
						color: #ffffff;
						line-height: 24px;
						text-align: left;
						font-style: normal;
					}
				}
			}

			.foot-right {
				.foot-right-code {
					width: 112px;
					height: 112px;
				}

				.foot-right-code__text {
					margin-top: 8px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #ffffff;
					line-height: 17px;
					text-align: center;
					font-style: normal;
				}
			}
		}

		.foot-bottom {
			width: 1200px;
			font-family: PingFangTC, PingFangTC;
			font-weight: 400;
			font-size: 14px;
			color: rgba(255, 255, 255, 0.56);
			line-height: 24px;
			text-align: center;
			font-style: normal;
		}
	}
</style>
